<div id="auth">
  <div class="background" (click)="closeAuthModal()"></div>
  <div class="wrapper">
    <div class="menu">
      <button (click)="closeAuthModal()">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
    <!-- <div class="login">
      <div class="title">Login</div>
      <div class="form">
        <div>
          <div class="label">Email</div>
          <div>
            <input type="text" />
          </div>
        </div>
        <div>
          <div class="label">Password</div>
          <div>
            <input type="text" />
          </div>
        </div>
        <div class="action">
          <button>Login</button>
        </div>
      </div>
      <div class="meta">
        <div class="label">Don't have an account?</div>
        <div>
          <button>Signup</button>
        </div>
      </div>
    </div> -->
    <div class="login">
      <div class="title">Signup</div>
      <div class="form">
        <div>
          <div class="label">Name</div>
          <div>
            <input type="text" />
          </div>
        </div>
        <div>
          <div class="label">Email</div>
          <div>
            <input type="text" />
          </div>
        </div>
        <div>
          <div class="label">Password</div>
          <div>
            <input type="text" />
          </div>
        </div>
        <div>
          <div class="label">Confirm password</div>
          <div>
            <input type="text" />
          </div>
        </div>
        <div>
          <div>
            <input type="checkbox" />
            By signing up you agree to our terms and privacy
          </div>
        </div>
        <div class="action">
          <button>Signup</button>
        </div>
      </div>
      <div class="meta">
        <div class="label">Already have an account?</div>
        <div>
          <button>Login</button>
        </div>
      </div>
    </div>
  </div>
</div>
